/** Map approval sourceModule → deep-link into the originating record (when known). */
export function approvalSourcePath(
  sourceModule: string,
  sourceEntityId?: number | null,
  options?: {
    sourceEntityType?: string | null;
    payload?: Record<string, unknown> | null;
  },
): string | null {
  if (!sourceEntityId && sourceModule !== 'mga' && sourceModule !== 'mga-periods') return null;
  switch (sourceModule) {
    case 'documents':
      return `/documents/${sourceEntityId}`;
    case 'spare-cases':
      return `/spares/spare-cases/${sourceEntityId}`;
    case 'supply-cases':
      return `/supplies/supply-cases/${sourceEntityId}`;
    case 'pms-work-orders':
      return `/pms/pms-work-orders/${sourceEntityId}`;
    case 'supply-requisitions':
      return `/supplies/requisitions/${sourceEntityId}`;
    case 'spare-requisitions':
      return `/spares/requisitions/${sourceEntityId}`;
    case 'supply-purchase-orders':
      return `/supplies/supply-purchase-orders/${sourceEntityId}`;
    case 'spare-purchase-orders':
      return `/spares/spare-purchase-orders/${sourceEntityId}`;
    case 'mga':
    case 'mga-periods': {
      const entityType = options?.sourceEntityType || '';
      const payload = options?.payload || {};
      const periodId =
        entityType === 'MgaPeriod'
          ? sourceEntityId
          : Number.isFinite(Number(payload.mgaPeriodId))
            ? Number(payload.mgaPeriodId)
            : sourceEntityId;
      if (!periodId) return '/mga';
      return entityType === 'MgaCrewRequest' ? `/mga/${periodId}/sheet` : `/mga/${periodId}`;
    }
    case 'e_forms':
      return `/e-forms/submissions/${sourceEntityId}`;
    default:
      return null;
  }
}

export function approvalSourceLabel(sourceModule: string): string {
  const labels: Record<string, string> = {
    documents: 'Documents',
    'spare-cases': 'Spare cases',
    'supply-cases': 'Supply cases',
    'pms-work-orders': 'Work orders',
    'supply-requisitions': 'Supply requisitions',
    'spare-requisitions': 'Spare requisitions',
    'supply-purchase-orders': 'Supply purchase orders',
    'spare-purchase-orders': 'Spare purchase orders',
    mga: 'MGA',
    'mga-periods': 'MGA periods',
    e_forms: 'E-Forms',
  };
  return labels[sourceModule] || sourceModule;
}
